import "@/localization/localization";
import {
  Navigate,
  RouterProvider,
  createBrowserRouter,
} from "react-router-dom";

import "./App.css";

import "./localization/localization";

import { IntroLanding } from "./pages/IntroLanding";
import { PrivacyPolicy } from "./pages/PrivacyPolicy/PrivacyPolicy";

const router = createBrowserRouter([
  {
    path: "/",
    element: <IntroLanding />,
  },
  {
    path: "/politica-privacidad",
    element: <PrivacyPolicy />,
  },
  {
    path: "/*",

    element: <Navigate to="/" />,
  },
]);

function App() {
  return (
    <div
      style={{
        position: "relative",
        height: "100%",
        width: "100%",
      }}
    >
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
